"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _InForm = _interopRequireDefault(require("./InForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getFormattedDate = date => {
  const format = date?.split('-');
  if (format.length !== 3) return '';
  const day = format[2];
  const month = format[1];
  const year = format[0];
  return `${day}.${month}.${year}`;
};
const getDefaultValues = (parameters, items, pathname, isInformFeedback, organisationData) => {
  const defaultValues = parameters?.map(param => ({
    id: param.split(':')[0],
    value: param.split(':')[1]
  }));
  let event_occurence_code = '';
  let hash = '';
  if (isInformFeedback) {
    const values = pathname.replace('agenda', 'cms')?.split('/inform/feedback/')?.at(-1)?.split('/');
    event_occurence_code = values[0];
    hash = values[1];
  }
  if (event_occurence_code) defaultValues.push({
    id: 'event_occurence_code',
    value: event_occurence_code
  });
  if (hash) defaultValues.push({
    id: 'hash',
    value: hash
  });
  if (organisationData?.contact_email) {
    defaultValues.push({
      id: 'send_email',
      value: organisationData.contact_email
    });
  }
  return Object.fromEntries(defaultValues.map(value => {
    const field = items[value.id];
    if (!field) return [undefined, undefined];
    const defaultValue = field['#type'] === 'select' ? {
      id: value.value.trim(),
      label: field['#options'][value.value.trim()]
    } : value.value;
    return [value.id, defaultValue];
  }));
};
const InFormItem = _ref => {
  let {
    lang,
    item,
    translate,
    inFormMethods,
    captchaKey,
    history,
    organisationData
  } = _ref;
  const pathname = history?.location?.pathname || '';
  const [items, setItems] = (0, _react.useState)();
  const [defaultValues, setDefaultValues] = (0, _react.useState)();
  const [feedbackValues, setFeedbackValues] = (0, _react.useState)({});
  const {
    fetchForm,
    onSubmitForm,
    fetchTerms,
    fetchNode
  } = inFormMethods;
  const isInformFeedback = pathname.includes('/inform/feedback/');
  (0, _react.useEffect)(() => {
    if (!item.form_id) return;
    fetchForm && fetchForm(lang, item.form_id, data => {
      setItems(data);
    });
  }, [item.form_id]);
  (0, _react.useEffect)(() => {
    if (items) {
      const auxValues = getDefaultValues(item.parameters, items, pathname, isInformFeedback, organisationData);
      if (isInformFeedback) getEventValues(auxValues);else setDefaultValues(auxValues);
    }
  }, [items]);
  const getEventValues = auxValues => {
    fetchNode(lang, auxValues.event_occurence_code, data => {
      setFeedbackValues(data);
      setDefaultValues({
        ...auxValues,
        event_occurence_code: data.occurence_code
      });
      if (auxValues.hash !== data?.hash.split('-')[0]) {
        history.push(`/${lang}/not-found`);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, feedbackValues?.occurence_code && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12 sia-margin-01-bottom"
  }, feedbackValues.occurence_code, " - ", feedbackValues.title), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12"
  }, feedbackValues.date_times && getFormattedDate(feedbackValues.date_times[0]?.date))), items && defaultValues && /*#__PURE__*/_react.default.createElement(_InForm.default, {
    lang: lang,
    form_id: item.form_id,
    confirmationPage: item.confirmation_page,
    defaultValues: defaultValues,
    items: items,
    translate: translate,
    onSubmit: onSubmitForm,
    fetchTerms: fetchTerms,
    captchaKey: captchaKey
  }));
};
var _default = exports.default = InFormItem;